"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemConfig = require("@/api/systemConfig");
var _validate = require("@/utils/validate");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  data: function data() {
    return {
      active: 0,
      tabList: [{
        tit: '热情红',
        class: 'bg1'
      }, {
        tit: '家居橙',
        class: 'bg2'
      }, {
        tit: '生鲜绿',
        class: 'bg3'
      }, {
        tit: '海鲜蓝',
        class: 'bg4'
      }, {
        tit: '女神粉',
        class: 'bg5'
      }],
      themeData: [],
      imgList: [require('@/assets/theme/theme1.png')],
      theme1: [require('@/assets/theme/theme1.png')],
      theme2: [require('@/assets/theme/theme2.png')],
      theme3: [require('@/assets/theme/theme3.png')],
      theme4: [require('@/assets/theme/theme4.png')],
      theme5: [require('@/assets/theme/theme5.png')]
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:system:config:change:color:get'])) this.getSet();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    selected: function selected(index) {
      this.active = index;
      if (index == 0) {
        this.$set(this, 'imgList', this.theme1);
      } else if (index == 1) {
        this.$set(this, 'imgList', this.theme2);
      } else if (index == 2) {
        this.$set(this, 'imgList', this.theme3);
      } else if (index == 3) {
        this.$set(this, 'imgList', this.theme4);
      } else if (index == 4) {
        this.$set(this, 'imgList', this.theme5);
      }
    },
    getSet: function getSet() {
      var _this = this;
      (0, _systemConfig.getSystemColorApi)().then(function (res) {
        _this.active = Number(res.value) - 1;
        if (res.value == 1) {
          _this.$set(_this, 'imgList', _this.theme1);
        } else if (res.value == 2) {
          _this.$set(_this, 'imgList', _this.theme2);
        } else if (res.value == 3) {
          _this.$set(_this, 'imgList', _this.theme3);
        } else if (res.value == 4) {
          _this.$set(_this, 'imgList', _this.theme4);
        } else if (res.value == 5) {
          _this.$set(_this, 'imgList', _this.theme5);
        }
      });
    },
    saveTheme: (0, _validate.Debounce)(function () {
      var _this2 = this;
      (0, _systemConfig.saveSystemColorApi)({
        value: this.active + 1
      }).then(function (res) {
        _this2.$message.success('编辑成功');
        _this2.$store.commit('settings/SET_mobileThemeColor', _this2.active + 1);
      });
    })
  }
};